import React from 'react';
import slugify from 'react-slugify';
import OpenApiFormGenerator from "../core/FormGenerator";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Paper, TextField } from '@mui/material';
import openapi_json from '../shared/openapi.json';


export default class ApiBrowser extends React.Component<any, any> {
    openapi: any = openapi_json;

    constructor(props: any) {
        super(props);
        this.state = {
            apiUrl: "",
            result: "",
            loading: false,
            tree: []
        };
    }

    buildPathTree = (path: string) => {
        let paths = path.split("/")

        if (paths.length <= 1) {
            return path;
        }
    }

    setResult = (result: any) => {
        if (typeof result === 'string') {
            this.setState({
                result: result,
                loading: false
            });
        } else{
            this.setState({
                result: JSON.stringify(result, undefined, 4),
                loading: false
            });
        }
    }

    handleInputChange = (event: any) => {
        this.setState({
            apiUrl: event.target.value
        });
    }

    loadApiJson = () => {
        this.setState({
            loading: true
        });

        fetch(this.state.apiUrl
        ).then((response) => {
            response.json().then((data) => {
                this.setState({
                    api: data,
                    loading: false
                });
            });
        }).catch((error) => {
            this.setState({
                loading: false
            });
            console.log(error);
        });
    }

    render() {
        let routes = [];

        const ordered_keys = Object.keys(this.openapi.paths).sort().reduce(
            (obj: any, key: any) => { 
                obj[key] = this.openapi.paths[key]; 
                return obj;
            }, 
            {}
        );

        for (const path_key in ordered_keys) {
            let path = this.openapi.paths[path_key];

            for (const method_key in path) {
                let route_key = method_key + "-" + slugify(path_key);
                routes.push(
                    <Accordion key={route_key + "-accordion"}>
                        <AccordionSummary
                            style={{minHeight: "40px", height: "40px"}}
                            key={route_key + "-accordion-summary"}
                            expandIcon={<ExpandMoreIcon key={route_key + "-expandicon"}/>}
                            aria-controls="panel1a-content"
                            id={"panel1a-header-" + route_key}
                        >
                            <Typography key={route_key + "-name"}>{method_key.toUpperCase()}&nbsp;{path_key}</Typography>
                        </AccordionSummary>
                        <AccordionDetails key={route_key + "-accordion-details"}>
                            <OpenApiFormGenerator
                                key={route_key + "-form"}
                                method={method_key}
                                path={path_key}
                                setResult={this.setResult}
                                handleInputChange={this.handleInputChange}
                                editAllFields={true}
                            />
                        </AccordionDetails>
                    </Accordion>
                );
            }
        }

        return (
            <>
                <Typography variant="h4" align="left" gutterBottom component="h2">
                    API Browser
                </Typography>
                {this.state.result === "" ?
                <> 
                    {/* https://api.apis.guru/v2/specs/googleapis.com/webmasters/v3/openapi.json */}
                    <TextField
                        fullWidth={true}
                        key={"api-url"}
                        id={"api-url"}
                        type="text"
                        helperText="Enter an OpenAPI .json file URL."
                        onChange={this.handleInputChange}
                        variant="standard"
                        size="medium"
                    />
                    <Button variant="contained" color="primary" onClick={() => this.loadApiJson()}>Load JSON</Button>
                    <br/>
                    <br/>
                    {routes}
                </> : 
                <>
                    <Button variant="contained" color="primary" onClick={() => this.setState({result: ""})}>Back</Button>
                    <br/>
                    <br/>
                    <Paper className='sj-paper'>
                        <pre className='sj-pre'><code>
                            {this.state.result}
                        </code></pre>
                    </Paper>
                </>
                }
            </>
        );
    }
}
